namespace Matrix.Indexation {
    export namespace FactCompositeConstituentService {
        export const baseUrl = 'Indexation/FactCompositeConstituent';

        export declare function Create(request: Serenity.SaveRequest<FactCompositeConstituentRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<FactCompositeConstituentRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<FactCompositeConstituentRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<FactCompositeConstituentRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Indexation/FactCompositeConstituent/Create",
            Update = "Indexation/FactCompositeConstituent/Update",
            Delete = "Indexation/FactCompositeConstituent/Delete",
            Retrieve = "Indexation/FactCompositeConstituent/Retrieve",
            List = "Indexation/FactCompositeConstituent/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>FactCompositeConstituentService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
